<template>
  <div class="rounded-md border border-gray-300 p-5" :class="editionClass">
    <div class="flex">
      <div class="flex-1">
        <h3 class="text-xl font-medium">
          {{ user.first_name }}&nbsp;{{ user.last_name }}
        </h3>
        <p>
          {{ user.email }}
        </p>
      </div>
      <div class="flex-shrink">
        <BaseButton
          color="secondary"
          :icon="buttonIcon"
          :tooltip="$t('button.show_v', { var: $t('global.user') })"
          @click="showForm"
        />
      </div>

      <BaseDeleteButton
        v-if="editionMode"
        :tooltip="$t('button.delete_v', { var: $t('global.user') })"
        class="ml-2"
        @click="deleteUser(user.id)"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CustomerUserCardComponent',
  props: {
    user: {
      type: Object,
      required: true
    },
    focusUser: {
      type: Object,
      required: false
    },
    editionMode: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      editionClass: '',
      focus: '',
      editable: false,
      errors: {},
      user: this.user
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'user/getUserMetadata',
      errors: 'auth/getErrors'
    }),
    buttonIcon() {
      return !this.editable ? 'search' : 'times'
    },
    editPasswordText() {
      return !this.editPassword
        ? 'modifier le mot de passe'
        : 'annuler la modification'
    },
    editPasswordIcon() {
      return !this.editPassword ? 'unlock' : 'times'
    },
    editPasswordType() {
      return !this.editPassword ? 'warning' : 'secondary'
    },
    editPassword() {
      return this.focusUser == null
    }
  },
  methods: {
    ...mapActions({
      fetchUserByID: 'user/fetchUserByID',
      deleteUserById: 'user/deleteUserById',
      undoDeleteUserById: 'user/undoDeleteUserById',
      storeNewCustomerUser: 'customer/storeNewCustomerUser',
      updateCustomerUser: 'customer/updateCustomerUser'
    }),
    async fetchUser(id) {
      await this.fetchUserByID({ id: id })
      this.user = this.$store.getters.getUser
      this.metadata = this.$store.getters.getUserMetadata
    },
    showForm() {
      this.$router.push({
        name: 'settings_edit_user_route',
        params: { id: this.user.id }
      })
    },
    getInputValue({ attribute, value }) {
      this.user[attribute] = value
    },
    submitForm() {
      if (this.user.id !== null) {
        this.user.customer_id = this.$route.params.id
        this.user.companies_id = null
        this.updateCustomerUser({
          user: this.user,
          id: this.user.id
        }).then(() => {
          this.$h.toastSuccess(
            this.$t('toasts.updated_m', { var: this.$t('attributes.user') })
          )
        })
      } else {
        this.user.customer_id = this.$route.params.id
        this.user.companies_id = null
        this.user.roles = ['customer-user']
        this.storeNewCustomerUser({
          user: this.user
        }).then(() => {
          this.$h.toastSuccess(
            this.$t('toasts.created_m', { var: this.$t('attributes.user') })
          )
        })
      }
    },

    deleteUser(id) {
      this.deleteUserById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.user') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteUser(id)
            }
          ]
        )
      })
    },
    undoDeleteUser(id) {
      this.undoDeleteUserById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_m', { var: this.$t('attributes.user') })
        )
      })
    }
  },
  watch: {
    editable(newValue, oldValue) {
      this.editionClass = this.editable ? 'col-span-2' : ''
    },
    focusUser(newValue, oldValue) {
      this.editable = newValue === this.user.id
    }
  },
  mounted() {
    if (this.user.id === null) {
      this.editable = true
    }
  }
}
</script>
